import type { ContentBlock, Reference } from '../types';
import { CitedContent } from './CitedContent';
import './SummaryContent.css';

interface SummaryContentProps {
  contentBlocks: ContentBlock[] | null;
  references: Reference[];
}

export function SummaryContent({ contentBlocks, references }: SummaryContentProps) {
  if (contentBlocks && contentBlocks.length > 0 && references) {
    return <CitedContent contentBlocks={contentBlocks} references={references} />;
  }

  return (
    <div className="summary-content">
      <div className="summary-content__text">
        No summary content available
      </div>
    </div>
  );
}
